<template>
  <v-layout column>
    <v-layout column class="pb-2">
      <v-flex shrink>
        <v-dialog
          v-model="absentDialog"
          max-width="600"
          v-if="!shift.employeeAbsent"
        >
          <v-checkbox
            slot="activator"
            label="Employee was absent"
            v-model="internalAbsent"
          />
          <v-card>
            <v-card-title class="headline">
              Mark Absent
            </v-card-title>
            <v-card-text>
              <v-textarea
                v-model="internalAbsentReason"
                label="Reason for absence"
              >
              </v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" flat @click="clearDialog"
                >Nevermind</v-btn
              >
              <v-btn
                color="success"
                @click="markAbsent"
                :disabled="internalAbsentReason === '' || absentPending"
                :loading="absentPending"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="presentDialog"
          max-width="600"
          v-if="shift.employeeAbsent"
        >
          <v-checkbox
            slot="activator"
            label="Employee was absent"
            v-model="internalAbsent"
          />
          <v-card>
            <v-card-title class="headline">
              Clear absent mark?
            </v-card-title>
            <v-card-text>
              <p>Confirming this will remove the absent mark from this shift. Only continue if you want to mark the employee as having been present.</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" flat @click="clearPresentDialog"
                >Nevermind</v-btn
              >
              <v-btn
                color="success"
                @click="markPresent"
                :loading="absentPending"
              >
                Confirm. Employee was present
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex>
        <div v-if="shift.employeeAbsent">
          <p>
            <strong>Absent reason</strong>: {{ shift.absentReason }}
          </p>
        </div>
      </v-flex>
    </v-layout>

    <v-layout justify-end row class="text-xs-right mb-3" v-if="user.bohOrHigher">
      <v-flex>
        <v-btn
          class="no-margin"
          :loading="timeclockCreatePending"
          :disabled="timeclockCreatePending"
          @click="createManagerClockEntry"
          color="success"
        >
          <v-icon left>
            add
          </v-icon>
          Timeclock entry
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex grow>
        <table style="width: 100%;">
          <thead>
            <tr>
              <th class="text-xs-left">Type</th>
              <th class="text-xs-left">Date</th>
              <th class="text-xs-left">Time</th>
            </tr>
          </thead>
          <tbody>
            <PunchRow
              :punch="punch"
              v-for="punch in sortedPunches"
              :key="punch.id"
              :editable="user.bohOrHigher"
            >
            </PunchRow>
          </tbody>
        </table>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import ApiField from '@/components/base/api-field.vue';
import { mapGetters } from 'vuex'
import PunchRow from '@/components/calendar/punch.vue'

export default {
  props: [
    'shift',
    'user',
  ],

  components: {
    ApiField,
    PunchRow,
  },

  data() {
    return {
      timeclockCreatePending: false,
      presentDialog: false,
      absentDialog: false,
      absentPending: false,
      internalAbsent: null,
      internalAbsentReason: '',
    }
  },

  computed: {
    ...mapGetters('timeclock', ['sortedPunches']),
  },

  created() {
    console.log('created ', this.shift)
    this.setInternalFields(this.shift)
  },

  watch: {
    shift(val) {
      console.log('shift watcher')
      if (val) {
        console.log('got val ', val)
        this.setInternalFields(val)
      }
    },

    internalAbsent(newVal, oldVal) {
      if (newVal === false && oldVal === true) {
        // un-setting absent checkbox
        console.log('was not absent')
        this.absentDialog = false
      }
    },
  },

  methods: {
    setInternalFields(shift) {
      this.internalAbsent = shift.employeeAbsent
      this.internalAbsentReason = shift.absentReason
    },

    createManagerClockEntry() {
      this.timeclockCreatePending = true;
      this.$store
        .dispatch('timeclock/managerCreate', this.shift.id)
        .then(res => {
          this.$store.dispatch('global/showSnackbarSuccess', {
            message: 'Timeclock entry created! Be sure to update it.',
          });
        })
        .catch(err => {
          this.$store.dispatch('global/showSnackbarError', {
            message: 'There was a problem creating a timeclock entry',
          });
        })
        .finally(res => {
          this.timeclockCreatePending = false;
        });
    },

    markAbsent() {
      this.absentPending = true
      this.$store.dispatch(
        'shifts/update', {
          id: this.shift.id,
          employee_absent: true,
          absent_reason: this.internalAbsentReason,
        }
      ).then((s) => {
        this.$store.dispatch('global/showSnackbarSuccess', {
          message: 'Employee marked absent',
        });
      }).catch((err) => {
        this.$store.dispatch('global/showSnackbarError', {
          message: 'There was a problem recording this absence',
        });
      }).finally(() => {
        this.absentPending = false
        this.absentDialog = false
      })
    },

    markPresent() {
      this.absentPending = true
      this.$store.dispatch(
        'shifts/update', {
          id: this.shift.id,
          employee_absent: false,
          absent_reason: null,
        }
      ).then((s) => {
        this.$store.dispatch('global/showSnackbarSuccess', {
          message: 'Employee marked present',
        });
      }).catch((err) => {
        this.$store.dispatch('global/showSnackbarError', {
          message: 'There was a problem clearing this absent mark',
        });
      }).finally(() => {
        this.absentPending = false
        this.presentDialog = false
      })
    },


    clearDialog() {
      this.absentDialog = false
      this.internalAbsent = null
      this.internalAbsentReason = ''
    },

    clearPresentDialog() {
      this.presentDialog = false
      this.internalAbsent = true
    }
  }

}
</script>
